import classNames from "classnames";
import {
  FC,
  ReactNode,
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { AppContext } from "../../../pages/profile/Profile";
import styles from "./Heading.module.scss";

export const Heading: FC<{
  children?: ReactNode;
}> = () => {
  const { keys, scrollY, isMobile } = useContext(AppContext);
  const [isStuck, setIsStuck] = useState(false);
  const headingRef = useRef<HTMLDivElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [baseHeight, setBaseHeight] = useState<number>(0);
  const stickyHeight = isMobile ? 48 : 56;

  useLayoutEffect(() => {
    if (!wrapperRef.current || typeof window === "undefined") {
      return;
    }
    if (isStuck) {
      return;
    }
    const rect = wrapperRef.current.getBoundingClientRect();
    setBaseHeight(rect.height);
  }, [isMobile, isStuck]);

  useEffect(() => {
    if (baseHeight <= 0 || scrollY === null) {
      return;
    }
    const threshold = baseHeight - stickyHeight;
    const buffer = 8;
    if (!isStuck && scrollY >= threshold + buffer) {
      setIsStuck(true);
      return;
    }
    if (isStuck && scrollY <= threshold - buffer) {
      setIsStuck(false);
    }
  }, [scrollY, baseHeight, stickyHeight, isStuck]);

  useLayoutEffect(() => {
    if (typeof document === "undefined") {
      return;
    }
    if (!isStuck) {
      document.documentElement.style.setProperty("--sticky-header-height", "0px");
      return;
    }
    if (!headingRef.current) {
      return;
    }
    const rect = headingRef.current.getBoundingClientRect();
    const offset = Math.max(0, rect.height - 2);
    document.documentElement.style.setProperty(
      "--sticky-header-height",
      `${offset}px`
    );
  }, [isStuck, isMobile]);
  return (
    <div
      ref={wrapperRef}
      className={styles.headingWrapper}
      style={isStuck && baseHeight ? { height: baseHeight } : undefined}
    >
      <div
        ref={headingRef}
        className={classNames(styles.heading, {
          [styles.continue]: !!scrollY && scrollY >= 100,
        })}
        data-stuck={isStuck}
      >
        <div className={styles.inner}>
          <div className={styles.title}>
            <h1>Eivind Eriksen</h1>
            <div className={styles.subtitle}>
              {keys.professionalTitle}
            </div>
          </div>
        </div>
        <div className={styles.arrow}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1920">
            <path
              fillRule="evenodd"
              d="M902.83 0v1699.925l-476.465-476.467L345 1304.823 960.177 1920l615.407-615.177-81.365-81.365-476.466 476.467V0z"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};
